var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "29px",
    viewBox: "0 0 30 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E306B831-CE19-40B0-9F44-B077A7B04A58") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-202.000000, -1466.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "iconDamage"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.470588,1468.11844 C214.510183,1466.1692 216.933113,1465.43178 218.882353,1466.47138 C219.582609,1466.84485 220.155942,1467.41818 220.529412,1468.11844 L231.529412,1488.74344 C232.569007,1490.69268 231.831593,1493.11561 229.882353,1494.1552 C229.303032,1494.46417 228.656563,1494.62579 228,1494.62579 L206,1494.62579 C203.790861,1494.62579 202,1492.83493 202,1490.62579 C202,1489.96923 202.161617,1489.32276 202.470588,1488.74344 Z M217.941176,1468.23608 C216.966556,1467.71629 215.755092,1468.08499 215.235294,1469.05961 L204.235294,1489.68461 C204.080809,1489.97427 204,1490.29751 204,1490.62579 C204,1491.73036 204.895431,1492.62579 206,1492.62579 L228,1492.62579 C228.328282,1492.62579 228.651516,1492.54498 228.941176,1492.3905 C229.915797,1491.8707 230.284503,1490.65923 229.764706,1489.68461 L218.764706,1469.05961 C218.577971,1468.70949 218.291304,1468.42282 217.941176,1468.23608 Z M217,1485.62579 C217.828427,1485.62579 218.5,1486.29736 218.5,1487.12579 C218.5,1487.95422 217.828427,1488.62579 217,1488.62579 C216.171573,1488.62579 215.5,1487.95422 215.5,1487.12579 C215.5,1486.29736 216.171573,1485.62579 217,1485.62579 Z M217,1474.62579 C217.552285,1474.62579 218,1475.0735 218,1475.62579 L218,1483.62579 C218,1484.17807 217.552285,1484.62579 217,1484.62579 C216.447715,1484.62579 216,1484.17807 216,1483.62579 L216,1475.62579 C216,1475.0735 216.447715,1474.62579 217,1474.62579 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWarning);
export default __webpack_public_path__ + "static/media/DashboardWarning.fb0ac8d93356db80cb993911d1107cf1.svg";
export { ForwardRef as ReactComponent };